module.exports = __webpack_public_path__ + "img/cab92f6.jpg";